'use client';
import { __rest } from 'tslib';
import React from 'react';
import { CheckIcon } from '@radix-ui/react-icons';
import { styled } from '../stitches.config.js';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { menuCss, itemCss, labelCss, separatorCss } from './Menu.js';
import { Box } from './Box.js';
import { Flex } from './Flex.js';
import { panelStyles } from './Panel.js';

const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
const StyledContent = styled(DropdownMenuPrimitive.Content, menuCss, panelStyles);
const DropdownMenuContent = React.forwardRef((props, forwardedRef) => (React.createElement(DropdownMenuPrimitive.Portal, null,
    React.createElement(StyledContent, Object.assign({}, props, { ref: forwardedRef })))));
const DropdownMenuItem = styled(DropdownMenuPrimitive.Item, itemCss);
const DropdownMenuGroup = styled(DropdownMenuPrimitive.Group, {});
const DropdownMenuLabel = styled(DropdownMenuPrimitive.Label, labelCss);
const DropdownMenuSeparator = styled(DropdownMenuPrimitive.Separator, separatorCss);
const StyledDropdownMenuCheckboxItem = styled(DropdownMenuPrimitive.CheckboxItem, itemCss);
const DropdownMenuCheckboxItem = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledDropdownMenuCheckboxItem, Object.assign({}, props, { ref: forwardedRef }),
        React.createElement(Box, { as: "span", css: { position: 'absolute', left: '$1' } },
            React.createElement(DropdownMenuPrimitive.ItemIndicator, null,
                React.createElement(CheckIcon, null))),
        children));
});
const DropdownMenuRadioGroup = styled(DropdownMenuPrimitive.RadioGroup, {});
const StyledDropdownMenuRadioItem = styled(DropdownMenuPrimitive.RadioItem, itemCss);
const DropdownMenuRadioItem = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledDropdownMenuRadioItem, Object.assign({}, props, { ref: forwardedRef }),
        React.createElement(Box, { as: "span", css: { position: 'absolute', left: '$1' } },
            React.createElement(DropdownMenuPrimitive.ItemIndicator, null,
                React.createElement(Flex, { css: { width: '$3', height: '$3', alignItems: 'center', justifyContent: 'center' } },
                    React.createElement(Box, { css: {
                            width: '$1',
                            height: '$1',
                            backgroundColor: 'currentColor',
                            borderRadius: '$round',
                        } })))),
        children));
});

export { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuTrigger };
